import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import ClassicRewardsReservationsPage from '../ClassicRewardsReservationsPage';
import LoyaltyPayForPointsPage from '../PayForPoints';
import SocieteEsimGeneratorPage from '../SocieteEsimGeneratorPage';
import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

type StatsSubTab = 'esim' | 'pay-for-points' | 'classic-rewards';

/**
 * Offers page: combines the eSIM generator, Pay-for-Points report, and
 * Classic Rewards reservations under a single top-level loyalty tab.
 */
export default function StatsPage() {
  const [tab, setTab] = useState<StatsSubTab>('esim');

  return (
    <Box>
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as StatsSubTab)}>
          <Tab value="esim" label="eSIM" />
          <Tab value="pay-for-points" label="Pay for Points" />
          <Tab value="classic-rewards" label="Classic Rewards" />
        </Tabs>
      </Box>

      {tab === 'esim' && <SocieteEsimGeneratorPage />}
      {tab === 'pay-for-points' && <LoyaltyPayForPointsPage />}
      {tab === 'classic-rewards' && <ClassicRewardsReservationsPage />}
    </Box>
  );
}
